import React, { useState } from "react";
import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/orderingSystem/logo.png";
import profilePic from "../../../assets/images/users/avatar-1.jpg";
import playBeep from "./PlayBeep";
import { setSoundOn } from "./PlayBeep";

const Header = ({ orgData }) => {
  const navigate = useNavigate();
  const orgCode = orgData?.orgCode;

  // Get user info from localStorage
  const customerInfo = JSON.parse(localStorage.getItem("CustomerInfo") || "{}");
  const isLoggedIn = customerInfo?.accessToken;

  // Dropdown state
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  // Sound state
  const [isSoundEnabled, setIsSoundEnabled] = useState(
    JSON.parse(localStorage.getItem("isSoundOn") ?? "true"),
  );
  const toggleSound = () => {
    const newSoundState = !isSoundEnabled;
    setIsSoundEnabled(newSoundState);
    setSoundOn(newSoundState);
    localStorage.setItem("isSoundOn", JSON.stringify(newSoundState));
  };

  const handleProfileClick = () => {
    if (!isLoggedIn) {
      navigate(`/${orgCode}/customer-login`);
    }
  };

  const handleMyProfile = () => {
    navigate(`/${orgCode}/customer-profile`, { state: { orgData } });
  };

  const handleMyOrders = () => {
    navigate(`/${orgCode}/customer-orders`, { state: { orgData } });
  };

  const handleLogout = () => {
    localStorage.removeItem("CustomerInfo");
    navigate(`/${orgCode}/customer-login`);
  };

  return (
    <div
      className="mb-3 px-2 py-2"
      style={{
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
      }}
    >
      <Row className="align-items-center">
        {/* Logo */}
        <Col xs="2" className="text-start">
          <img
            src={logo}
            alt="Logo"
            style={{
              width: "70px",
              height: "70px",
              objectFit: "contain",
              borderRadius: "8px",
            }}
            onClick={() => {
              playBeep();
              navigate(`/${orgData?.orgCode}`);
            }}
          />
        </Col>

        {/* Company Info */}
        <Col xs="8" className="text-center">
          <h4
            className="mb-1 fw-bold"
            style={{ color: "#2c3e50", fontSize: "18px" }}
          >
            {orgData?.name || "Restaurant"}
          </h4>
          <div
            style={{ fontSize: "11px", color: "#6c757d", lineHeight: "1.4" }}
          >
            <div className=" d-flex align-items-center justify-content-center gap-1">
              <i className="bx bx-phone" style={{ fontSize: "13px" }} />
              <span>{orgData?.tel || orgData?.contactNo || ""}</span>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-2 mt-1">
              <div className="d-flex align-items-center gap-1  ">
                <i className="bx bx-map" style={{ fontSize: "13px" }} />
                <span>{orgData?.address1 || ""}</span>
              </div>
              <div className="d-flex align-items-center gap-1">
                <i className="bx bx-envelope" style={{ fontSize: "13px" }} />
                <span>{orgData?.email || orgData?.adminEmail || ""}</span>
              </div>
            </div>
          </div>
        </Col>


        {/* Profile Dropdown */}
<Col
    xs="2"
    className="d-flex align-items-center justify-content-end gap-2"
    style={{ position: "relative", zIndex: 1050 }}
  >
    {/* Sound */}
    <button
      onClick={toggleSound}
      style={{
        background: "none",
        border: "none",
        cursor: "pointer",
        fontSize: "22px",
        color: isSoundEnabled ? "#28a745" : "#6c757d",
      }}
      title={isSoundEnabled ? "Mute Sound" : "Unmute Sound"}
    >
      <i
        className={
          isSoundEnabled ? "bx bx-volume-full" : "bx bx-volume-mute"
        }
      />
    </button>

    {/* Profile */}
    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
      <DropdownToggle tag="div" style={{ cursor: "pointer" }}>
        <img
          src={profilePic}
          alt="Profile"
          style={{
            width: "35px",
            height: "35px",
            borderRadius: "50%",
            objectFit: "cover",
          }}
          onClick={() => {
            playBeep();
            handleProfileClick();
          }}
        />
      </DropdownToggle>

      {isLoggedIn && (
        <DropdownMenu end>
          <DropdownItem onClick={handleMyProfile}>
            My Profile
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem onClick={handleLogout}>
            Logout
          </DropdownItem>
        </DropdownMenu>
      )}
    </Dropdown>
  </Col>
      </Row>
    </div>
  );
};

export default Header;
